import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISpaceTypesList } from '../../../Pages/SpaceTypes/ISpaceTypes';

interface IUpdate extends IReduxState<ISpaceTypesList> {
  updateableDate?: ISpaceTypesList;
}

export const UpdateSpaceTypesSlicer = createSlice({
  name: 'UpdateSpaceTypes',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateSpaceTypes: (state, _) => {
      state.isLoading = true;
    },
    successUpdateSpaceTypes: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateSpaceTypes: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    SpaceTypesUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateSpaceTypesState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateSpaceTypes,
  failureUpdateSpaceTypes,
  successUpdateSpaceTypes,
  SpaceTypesUpdateableData,
  clearUpdateSpaceTypesState,
  clearUpdateableData,
} = UpdateSpaceTypesSlicer.actions;

export default UpdateSpaceTypesSlicer.reducer;
